<template>
  <div class="onboarding">
    <div class="onboarding-title">
      <h4>Welcome to <span>AuthX</span></h4>
      <p>Create secure & beautiful onboarding pages</p>
    </div>
    <div class="onboarding-image">
      <img
        :src="getImage('products/authx-form.svg')"
        alt="AuthX"
        class="fadeIn"
      />
      <img
        :src="getImage('products/divider.svg')"
        alt="AuthX"
        class="divider fadeIn"
      />
      <img
        :src="getImage('products/authx.svg')"
        alt="AuthX"
        class="authx fadeIn"
      />
    </div>
    <div class="onboarding-actions">
      <el-button type="primary" @click="showProductOptIn = true"
        >Create now</el-button
      >
    </div>
    <product-notification :show.sync="showProductNotification" />
    <product-opt-in
      :show.sync="showProductOptIn"
      :product="'authx'"
      @success="goToAuthX"
    />
  </div>
</template>

<script>
import ProductNotification from "@/components/Products/ProductNotification";
import ProductOptIn from "@/components/Products/ProductOptIn";
import { isProductAccessible, userCan } from "@/lib/utils";

export default {
  name: "AuthXOnboarding",
  components: { ProductNotification, ProductOptIn },
  data() {
    return {
      showProductNotification: false,
      showProductOptIn: false
    };
  },
  mounted() {
    setTimeout(() => {
      this.showProductNotification = true;
    }, 1000);
  },
  methods: {
    goToAuthX() {
      this.$router.push({ name: "authx.index" });
    }
  },
  beforeRouteEnter(to, from, next) {
    const allowAdmin = userCan("auth", "feature.saveorganisationfeature");
    const allowProductView = isProductAccessible("authx");

    if (!allowProductView && allowAdmin) {
      next();
    } else {
      next({ name: "authx.index" });
    }
  }
};
</script>

<style lang="scss" scoped>
.onboarding {
  width: 100%;
  padding: 40px 20px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &-title {
    text-align: center;
  }

  &-image {
    padding: 12px;
    height: 380px;
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 30px 0;
    border-radius: 10px;

    img {
      border-radius: 10px;
      height: 100%;
      width: auto;
      box-shadow: 0 0 30px 0 rgb(82 63 105 / 7%);

      &:not(:last-child) {
        margin-right: 20px;
      }

      &.divider {
        border-radius: 1000px;
        height: 40px;
        -webkit-animation-delay: 0.5s;
        animation-delay: 0.5s;
      }

      &.authx {
        -webkit-animation-delay: 1s;
        animation-delay: 1s;
      }
    }
  }
}
</style>
